import axiosClient from './axiosClient'

const businessBranchApi = {
  find: (params, signal) => {
    const url = '/business-branch/find'
    return axiosClient.get(url, { params, signal })
  },
  update: (body) => {
    const url = '/business-branch/update'
    return axiosClient.post(url, body)
  },

  delete: (params) => {
    const url = '/business-branch/deletes'
    return axiosClient.delete(url, {
      data: {
        businessBranchCodes: params,
      },
    })
  },

  setDefultUsed: (body) => {
    const url = '/business-branch/set-defultused'
    return axiosClient.post(url, body)
  },

  getAll: (params, signal) => {
    const url = '/business-branch/getAll'
    return axiosClient.get(url, { params, signal })
  },
}

export default businessBranchApi
